import {betaFlagsDimension} from '@packages/systems/designer/beta-features';
import {abilityFeature} from '../abilityFeature';

export const betaFlags = abilityFeature({
  key: 'betaFlags',
  isValid: function isBetaFlagsValid(state, flagsToCheck) {
    return betaFlagsDimension.isValid(state, flagsToCheck);
  },
});
